import { CommonModule } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ModalShellComponent, ModalShellConfig } from '../modal-shell/modal-shell.component';

interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'app-confirm-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule, ModalShellComponent],
  template: `
    <app-modal-shell [config]="modalConfig">
      <div modal-content class="confirm-dialog">
        <div class="dialog-message">
          <div class="dialog-message__icon">
            <mat-icon class="warning-icon">warning</mat-icon>
          </div>
          <p>{{ data.message }}</p>
        </div>
      </div>

      <ng-container modal-actions>
        <button
          mat-stroked-button
          type="button"
          (click)="onCancel()">
          {{ data.cancelText || 'Cancelar' }}
        </button>
        <button
          mat-flat-button
          type="button"
          color="primary"
          class="confirm-button"
          (click)="onConfirm()">
          {{ data.confirmText || 'Confirmar' }}
        </button>
      </ng-container>
    </app-modal-shell>
  `,
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<ConfirmDialogComponent>);
  readonly modalConfig: ModalShellConfig;

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) {
    this.modalConfig = { title: data.title, size: 'sm', layout: 'confirm' };
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
